// Спільна логіка "тихого" підвантаження user.value за наявним JWT-токеном.
//
// Робимо кілька спроб і НЕ чіпаємо токен при мережевих помилках (таймаут,
// нестабільний мобільний інтернет - типово для iPhone/Safari при оновленні
// сторінки) - сесія лишається живою, і user.value підвантажиться пізніше.
// Токен видаляємо лише при явній відповіді 401/403 (дійсно недійсний токен).
export async function hydrateStrapiUser () {
  const user = useStrapiUser()
  const token = useStrapiToken()

  if (!token.value || user.value) return !!user.value

  const client = useStrapiClient()
  const config = import.meta.server ? useRuntimeConfig() : useRuntimeConfig().public

  const maxAttempts = 3
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      user.value = await client('/users/me', { params: config.strapi.auth })
      return true
    } catch (e) {
      const status = e?.error?.status
      if (status === 401 || status === 403) {
        token.value = null
        return false
      }
      if (attempt < maxAttempts && import.meta.client) {
        await new Promise(resolve => setTimeout(resolve, attempt * 400))
      }
    }
  }
  return false
}
